/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, HeaderContent, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import HeaderPrimitive from "../primitive/HeaderPrimitive"
import LinkContainer from "../useful/LinkContainer"
import Dummy from "./Dummy"
import { Overlay2 } from "@blueprintjs/core"
import { useOverTopScroll } from "src/modules/pe-landing-module/hooks/useOverTopScroll"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { ILayoutStore, useLayoutStore } from "src/settings/zustand"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { CONTAINER_CONTAINER } from "src/libs/interfaces/layouts"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import { __, getID } from "src/libs/utilities"


/* Protopia Ecosystem component */
export interface IHeaderProps {
    section: ILandingSection
    data: HeaderContent 
}
const Header = ({data, ...props}: IHeaderProps): JSX.Element => {
    const ref                   = useRef(null)   
    const {position}              = usePosition(data)
    const currentLanding: ILanding = useLandingStore((state: ILandingStore) => state.currentLanding) 
    const headerHeight: number  = useLayoutStore((state: ILayoutStore) => state.headerHeight)
    const [marginLeft]          = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]         = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]           = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]        = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [width]               = useState<string>(getCssDemention( position.width || data.width,  "inherit" ))
    const [height, ]            = useState<string>(getCssDemention( position.height || data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-header-${data.id}`,
            `.landing-header-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height }; 
                position:relative;
                ${
                    !!data.vertical 
                        ? `
                        flex-direction: column; align-items: center; justify-content: center;` 
                        : 
                        ``
                }
            }
            .landing-overtop-header-${ data.id } {
                top: ${ currentLanding.hideOriginalHeader ? 0 : headerHeight + 0 }px;
                height: 90px;
                left:0;
                width: calc(100% - 8px);
                overflow: hidden!important;
                outline: none!important;
                position: absolute;
                .overtop-header {
                    color: ${ data.overtopTypo?.text_color || data.overtopStyle?.color || "var(--force-contast-color)"};
                    width: 100%;
                    justify-content: space-between; 
                    ${data.overtopBlurDrop ? `backdrop-filter: blur(${ data.overtopBlurDrop }px);`: ""}
                    position: relative;
                    &:before {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background-color: ${ data.overtopBackground || data.overtopStyle?.backgroundColor || "var(--force-plain-color)"}; 
                    }
                }
            }
            `
        )           
        return () => {
            removeCSSClass(`landing-header-${data.id}`)
        }
    },[ ]) 
    
    return <LinkContainer
        link_url={data.link_url}
        link_target={data.link_target}
        className={`landing-content-container link-${data.id}`} 
        data-type={data.type}
        data-content-id={ data.id.toString() }
    > 
        {
            !!data.logo || !!data.contacts || !!data.menu
                ?
                <div 
                    className={`landing-header landing-header-${data.id} ${ data.className || "" } `} 
                    style={ data.style || {} } 
                    ref={ ref }
                >
                    <HeaderPrimitive  
                        primitive={{
                            ...( data ), 
                            height: props.section.height || 70,
                            vertical: data.vertical
                        } as any }  
                    /> 
                    {/* <OverlayHeader data={data} {...props} top={top}/> */}
                </div>
                :
                <Dummy {...{ 
                    data: {...data, className: `landing-header-${data.id}`}, 
                    ...props 
                }} />
        } 
        <DataContentEditor data={data} section={props.section}  />
    </LinkContainer> 
       
}
export default Header

interface IOverlayHeaderProps extends IHeaderProps {
    top: number
}
const OverlayHeader = ({data, ...props}: IOverlayHeaderProps): JSX.Element => { 
    if( !data.isOvertopSwicth || useLandingStore.getState().isEdit ) {
        return <></>
    }

    const menuItems = {...{...data.menu, ...data.overtopMenu }}
    const contactsItems = {...data.contacts, ...data.overtopContacts}
    const menu      = data.vertical
        ?
        {
            menuItems,
            items: [
                {
                    id: getID("hamburger"),
                    children: menuItems.items,
                    title: "", 
                    isDisable: (menuItems.items || []).length + (contactsItems.items || []).length > 5,
                    icon: "fas fa-bars fa-2x"
                }
            ], 
            text_color: data.overtopTypo?.text_color,

        }
        :
        {...data.menu, ...data.overtopMenu, text_color: data.overtopTypo?.text_color, }

    const logo      = {...data.logo, ...data.overtopLogo, text_color: data.overtopTypo?.text_color,}
    const contacts  = {...contactsItems, text_color: data.overtopTypo?.text_color, }
    
    return <Overlay2 isOpen={ props.top > 60 } hasBackdrop={ false } portalClassName="z-index-90">
            <div className={`landing-overtop-header-${ data.id }`} >
                <div className={`overtop-header heder-animation ${data.overtopClassName}`} >
                    <div className={ CONTAINER_CONTAINER[ (props.section.composition.container || CONTAINER_CONTAINER.large ) as keyof typeof CONTAINER_CONTAINER ] }>
                        <HeaderPrimitive  
                            primitive={{
                                ...({
                                    menu,
                                    logo,
                                    contacts,
                                    style: data.overtopStyle, 
                                } ),
                                text_color: data.overtopTypo?.text_color,
                                height: data.height || 70,
                                vertical: false
                            } as any }  
                        /> 
                    </div> 
                </div>
            </div> 
        </Overlay2> 
}